module.exports = __webpack_public_path__ + "media/src/images/photos/curtain-cef26148b23014cd75c30581e3d81adb.jpg";